<div *ngIf="loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    Unable to load the data sheet. Please check the link provided to you and retry.
</div>

<div *ngIf="!loadError && loading" class="pd-sheet-loading">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<div [hidden]="loadError || loading" class="pd-pdf-viewer">
    <ng2-pdfjs-viewer
        #pdfViewerOnDemand
        [downloadFileName]="fileName"
        [openFile]="false"
        [viewBookmark]="false"
        [startDownload]="autoDownload"
        >
    </ng2-pdfjs-viewer>
</div>
